//
// turbofunctions() v 3.0
//

function timeNow() {
	var date = new Date(),
		HOUR = date.getHours(),
		MINUTES = date.getMinutes(),
		SECONDS = date.getSeconds();
	HOUR = HOUR < 10 ? '0' + HOUR : HOUR;
	MINUTES = MINUTES < 10 ? '0' + MINUTES : MINUTES;
	SECONDS = SECONDS < 10 ? '0' + SECONDS : SECONDS;
	return HOUR + ':' + MINUTES + ':' + SECONDS
}

function externalLinksToNextWindow(containers) {

	function getLinks(tag) {
		// var ELEM = tag.querySelectorAll('h2, h3, h4, p, li, .btn, .link, .cc-johnson-box'),
		var ELEM = tag.querySelectorAll('a'),
			TT_L = ELEM.length;

		for (var a = 0; a < TT_L; a++) {
			if (ELEM[a].tagName.toLowerCase() === 'a') {

				if (ELEM[a].href &&
					ELEM[a].getAttribute('href').length > 0 &&
					ELEM[a].getAttribute('href').indexOf('mailto:') == -1 &&
					ELEM[a].getAttribute('href').indexOf('tel:') == -1
				) {
					var HOME_URL = window.location.host,
						INDEX = ELEM[a].href.indexOf(HOME_URL);

					if ( (INDEX == -1 || INDEX >= 9) && ELEM[a].target !== '_self') {
						ELEM[a].target = '_blank';
					}
				}

			} else {
				var LINK = ELEM[a].querySelectorAll('a'),
					L_L = LINK.length;

				for (var l = 0; l < L_L; l++) {

					if (LINK[l].href &&
						LINK[l].getAttribute('href').length > 0 &&
						LINK[l].getAttribute('href').indexOf('mailto:') == -1 &&
						LINK[l].getAttribute('href').indexOf('tel:') == -1
					) {
						var HOME_URL = window.location.host,
							INDEX = LINK[l].href.indexOf(HOME_URL);

						if (INDEX == -1 || INDEX >= 9) {
							LINK[l].target = '_blank';
						}
					}
				}
			}
		}
	}

	if (typeof containers == 'string') {
		var CONT_BOX = document.querySelectorAll(containers),
			TB_L = CONT_BOX.length;
		for (var i = 0; i < TB_L; i++) {
			getLinks(CONT_BOX[i]);
		}
	} else if (typeof containers == 'object') {
		getLinks(containers);
	}
}

// usage
// ajax('filePath', function(data) {});
// GET POST PUT DELETE HEAD CONNECT OPTIONS TRACE
function ajax(path, success, error) { // path => object { url: path, action, type, data }
	if ( window.XMLHttpRequest ) {

		if (path instanceof Array) {
			path.map( (eachPath, i) => {
			let xhr = new XMLHttpRequest();
				xhr.onreadystatechange = function() {
					if (xhr.readyState === XMLHttpRequest.DONE) {
						if (xhr.status === 200) {
							if (success) {
								success( { index: i, data: xhr.responseText } ); // cb function
							}
						} else {
							if (error) {
								error(xhr);  // cb function
							}
						}
					}
				}
	
				xhr.open("GET", eachPath, true); // set type, eachPath => action path
				xhr.send(null);
			} )
		} else {
			let xhr = new XMLHttpRequest();
			xhr.onreadystatechange = function() {
				if (xhr.readyState === XMLHttpRequest.DONE) {
					if (xhr.status === 200) {
						if (success) {
							success(xhr.responseText);  // cb function
						}
					} else {
						if (error) {
							error(xhr);  // cb function
						}
					}
				}
			};

			xhr.open("GET", path, true); // set type, eachPath => action path
			xhr.send(null); // data
		}
		
	} else {
		console.log( 'window.XMLHttpRequest is not supported' )
	}
}

// fetch('/wp-json/wp/v2/media/348').then( response => { console.log( response ) } )
const fetch = (url) => {
    return new Promise( resolve => {
        ajax( url, (arr) => { resolve( arr ) } )
    })
}

function preventEventDefaults(e) {
	if (!e) {
		e = window.event;
	}
	if (e.preventDefault) {
		e.preventDefault();
	}
	e.returnValue = false;
}

// checkObj(Object)
function checkObj(prop) {
	return Object.keys(prop).length > 0;
}

// isNr(variable)
function isNr(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

const isNum = (val) => {
	return /^\d+$/.test(val);
} 

const sortByName = ( a, b ) => {
	if (a < b) return -1
	if (a > b) return 1
	return 0
}

const maxValFromArray = array => Math.max(...array)

// getSTP() == Scroll from Top Position
function getSTP() {
	var d = document.documentElement,
		st = (window.pageYOffset || d.scrollTop) - (d.clientTop || 0);
	return parseInt(st)
}

const requestAnimationFrame = (f) => {
	return (
		window.requestAnimationFrame(f) ||
		window.mozRequestAnimationFrame(f) ||
		window.webkitRequestAnimationFrame(f) ||
		window.msRequestAnimationFrame(f) ||
		function(f) {
			return setTimeout(f, 1000 / 60)
		}
	)
} 

const cancelAnimationFrame = (f) => {
	return (
		window.cancelAnimationFrame(f) || 
		// window.webkitCancelAnimationFrame(f) || 
		// window.webkitCancelRequestAnimationFrame(f) || 
		// window.mozCancelAnimationFrame(f) || 
		function(f) {
			clearTimeout(f)
		}
	)
}

const mouseWheel = /Firefox/i.test(navigator.userAgent) ? 'DOMMouseScroll' : 'mousewheel'

const addEventListener = (element, type, callback) => {
	if (element.addEventListener) {
		element.addEventListener(type, callback, false);
	} else if (element.attachEvent) {
		element.attachEvent('on' + type, callback);
	}
};

Element.prototype.setProperty = function(property, value) {
	this.style.setProperty('-webkit-' + property, value);
	this.style.setProperty('-moz-' + property, value);
	this.style.setProperty('-ms-' + property, value);
	this.style.setProperty('-o-' + property, value);
	this.style.setProperty(property, value);
	return this;
}

Element.prototype.removeProperty = function(property) {
	this.style.removeProperty('-webkit-' + property);
	this.style.removeProperty('-moz-' + property);
	this.style.removeProperty('-ms-' + property);
	this.style.removeProperty('-o-' + property);
	this.style.removeProperty(property);
	return this;
}

const transform = (element, prop) => {
	element.style.transform = prop
	element.style.OTransform = prop // Opera
	element.style.msTransform = prop // IE 9
	element.style.MozTransform = prop // Firefox
	element.style.WebkitTransform = prop // Safari and Chrome
}

Element.prototype.transform = function(prop) {
	return transform(this, prop)
}

const checkCursor = (e) => {
	if (e.type == 'mousedown') {
		var e = e;
	} else if (e.touches) {
		var e = e.touches[0];
	}
	return { x: e.clientX, y: e.clientY }
};

const b64EncodeUnicode = (str) => {
	// first we use encodeURIComponent to get percent-encoded UTF-8,
	// then we convert the percent encodings into raw bytes which
	// can be fed into btoa.
	return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
		function toSolidBytes(match, p1) {
			return String.fromCharCode('0x' + p1);
		}
	));
}

const b64DecodeUnicode = (str) => {
	// Going backwards: from bytestream, to percent-encoding, to original string.
	return decodeURIComponent(atob(str).split('').map(function(c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));
}

// 'string'.capitalizeFirstLetter()
String.prototype.capitalizeFirstLetter = function() {
	return this.charAt(0).toUpperCase() + this.slice(1);
}

// document.getElementById('single_content').offset().top
Element.prototype.offset = function() {
	var _t, top, left, height, width, obj;
	_t = this.getBoundingClientRect()
	top = getSTP() + _t.top
	left = _t.left
	height = _t.height
	width = _t.width
	obj = {
		'top': parseInt(top),
		'left': parseInt(left),
		'width': parseInt(width),
		'height': parseInt(height)
	}
	return obj
}

const getParentByClassName = ( elem, value ) => {
    if ( !elem ) return false
    if ( elem.className.indexOf(value) > -1 ) return elem
    if ( elem.parentNode === document ) return false

    elem = elem.parentNode
    return getParentByClassName( elem, value )
}

// element.getClosest('.class')
Element.prototype.getClosest = function(selector) {
	let elem = this
	while (elem) {
		if ( elem === document.documentElement ) return false
		if ( elem.parentNode.querySelector(selector) ) return elem
		elem = elem.parentNode
	}
	return false
}

// element.getParentNode(number)
Element.prototype.getParentNode = function(count) {
	var elem = this;
	for (let i = 0; i < count; i++) elem = elem.parentNode
	return elem
}

// element.rm()
Element.prototype.rm = function() {
	this.parentNode.removeChild(this);
}

// String.concatString(newString)
String.prototype.concatString = function(value) {
	if (!value) return this
	if (typeof value === 'number' || 'boolean') value = String(value);
	if (value.length == 0) return this

	var c = this,
		attr, attr_l,
		add_value, add_value_l,
		c_new = '',
		space;

	if (!c || c.length === 0) {
		c_new = value
	} else {

		attr = c.split(' ');
		attr_l = attr.length;
		add_value = value.split(' ');
		add_value_l = add_value.length;

		for (var i = 0; i < attr_l; i++) {
			for (var a = 0; a < add_value_l; a++) {
				if (attr[i] === add_value[a]) {
					attr.splice(i, 1);
					// return
				}
			}
		}

		attr = attr.concat(add_value);
		attr_l = attr.length;

		for (var i = 0; i < attr_l; i++) {
			space = ' ';
			if (i === attr_l - 1) space = '';
			c_new += attr[i] + space;
		}
	}

	return c_new;
}

// element.hasAttr('class', 'active')
// will not add indexed value cuz its already indexed, make array
Element.prototype.hasAttr = function(attribute, thisValue) {
	var c = this.getAttribute(attribute);
	if (c) {
		if (!thisValue && thisValue !== false) {
			return true
		}  else if (typeof thisValue === 'boolean') {
			return thisValue
		} else {
			thisValue = String(thisValue);
		
			var arr = c.split(' '),
				arr_l = arr.length;
			thisValue = thisValue.replace(/\s+/g, '');

			for (var i = 0; i < arr_l; i++) {
				if (thisValue, arr[i] === thisValue) {
					return true;
				} else if (i == arr_l - 1) {
					return false;
				}
			}
		}
	} else {
		return false;
	}
}

// element.addAttr('attrname', 'attrvalue')
// no style support
Element.prototype.addAttr = function(attribute, thisValue = false) {
	if (typeof thisValue === 'number' || 'boolean')  thisValue = thisValue.toString();
	
	var c = this.getAttribute(attribute),
		attr, attr_l,
		add_value, add_value_l,
		c_new = '',
		space;

	if (!c || c.length === 0) {
		this.setAttribute(attribute, thisValue)
	} else {

		attr = c.split(' ');
		attr_l = attr.length;
		add_value = thisValue.split(' ');
		add_value_l = add_value.length;

		for (var i = 0; i < attr_l; i++) {
			for (var a = 0; a < add_value_l; a++) {
				if (attr[i] === add_value[a]) {
					// attr.splice(i, 1);
					return
				}
			}
		}

		attr = attr.concat(add_value);
		attr_l = attr.length;

		for (var i = 0; i < attr_l; i++) {
			space = ' ';
			if (i === attr_l - 1) space = '';
			c_new += attr[i] + space;
		}
		// console.log(
		// 	attr, '\n',
		// 	add_value, '\n',
		// 	c_new
		// );

		this.setAttribute(attribute, '');
		if (c_new) this.setAttribute(attribute, c_new)
	}

	return this;
}

// element.rmAttr('attrname', 'attrvalue attrvalue2 attrvalue3')
Element.prototype.rmAttr = function(attribute, thisValue) {
	var c = this.getAttribute(attribute),
		attrArr, attrArrLen,
		rmValueArr,
		c_new = '';
	if (c) {
		if (!thisValue) {
			this.removeAttribute(attribute);
		} else {
			let spliced = false;

			attrArr = c.split(' ');
			rmValueArr = thisValue.split(' ');
			attrArr.map( ( attr, i ) => {
				rmValueArr.map( value => {
					if ( attr === value ) {
						attrArr.splice(i, 1)
						spliced = true
					}
				})
			})

			if ( !spliced ) return
			
			attrArrLen = attrArr.length;
			attrArr.map( ( attr, i ) => {
				c_new += attr + `${ i === attrArrLen - 1 ? '' : ' '}`
			})

			this.setAttribute(attribute, '');
			if (c_new) this.setAttribute(attribute, c_new)
		}
	} else {
		this.removeAttribute(attribute);
	}

	return this;
}

// element.addClass('classvalue')
Element.prototype.addClass = function(thisValue) {
	this.addAttr('class', thisValue);
	return this;
}

// element.rmClass('classvalue')
Element.prototype.rmClass = function(thisValue) {
	this.rmAttr('class', thisValue);
	return this;
}

String.prototype.hasWord = function(val) {
    var arr = this.split(' '),
        arrLen = arr.length;
    val = val.replace(/\s+/g, '');

    for (var i = 0; i < arrlen; i++) {
        if (val, arr[i] === val) {
            return true;
        } else if (i == arrlen - 1) {
            return false;
        }
    }
}

// element.insAfter('.class || #id || tag || [attr]')
Element.prototype.insAfter = function(elem) {
	var ae = this.parentNode.children,
		ae_l = ae.length;
	for (var i = 0; i < ae_l; i++) {
		if (ae[i] === this && i !== ae_l - 1) {
			this.parentNode.insertBefore(elem, ae[i + 1]); // if this is not last
		} else if (ae[i] === this && i == ae_l - 1) {
			this.parentNode.appendChild(elem) // if this is last
		}
	}
}

Element.prototype.wrapElem = function(tagname, attrname, attrvalue) {
	var tag = document.createElement(tagname),
		wrapper = this.parentNode.insertBefore(tag, this);
	wrapper.appendChild(this).parentNode.addAttr(attrname, attrvalue);
}

Element.prototype.wrapChildren = function(tagname, attrname, attrvalue) {
	var tag = document.createElement(tagname),
		ch = this.children,
		ch_l = ch.length;
	tag.addAttr(attrname, attrvalue);
	this.appendChild(tag);
	for (var i = 0; i < ch_l; i++) {
		tag.appendChild(ch[0]);
	}
}

Element.prototype.onDoubleTap = function(cb) {

	const state = {
		taps: 0,
		now: 0
	}

	this.onclick = (e) => {

		if ( state.taps < 2 ) state.taps++
		if ( state.taps === 1 ) state.now = Date.now()
		
		let time = state.now - Date.now();

		if ( time <= 500 && time > 0 && state.taps === 2 ) {
			state.taps = 0
			state.now = 0
			cb()
		}

		if ( time > 500 || time <= 0 ) {
			state.taps = 0
			state.now = 0
		}

		console.log( state.taps, time )
	}
}

const elementInWindow = element => {
	return getSTP() + window.innerHeight > parseInt(element.offset().top) && getSTP() + window.innerHeight < parseInt(element.offset().top) + window.innerHeight + parseInt(element.offsetHeight)
}

const htmlEntities = str => {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    // return String(str).replace(/(&lt;)/g, '<').replace(/(&gt;)/g, '>')
}

export {
	timeNow,
	externalLinksToNextWindow,
	ajax,
	fetch,
	preventEventDefaults,
	checkObj,
	isNr,
	maxValFromArray,
	isNum,
	getSTP,
	elementInWindow,
	sortByName,
	getParentByClassName,
	requestAnimationFrame,
	cancelAnimationFrame,
	addEventListener,
	checkCursor,
	b64EncodeUnicode,
	b64DecodeUnicode,
	htmlEntities,
	mouseWheel
}



// obj instanceof Array (WORKS HARD)
// and this below not works hard
// if (typeof Array.isArray === 'undefined') {
// 	Array.isArray = function(obj) {
// 		return Object.prototype.toString.call(obj) === '[object Array]';
// 	}
// };

// create changing tags function:
// document.getElementById("93").outerHTML =
// document.getElementById("93").outerHTML.replace(/<wns/g,"<lmn").replace(/wns>/g,"lmn>")

// new Promise(function(resolve, reject) {});

// method to change html elements array into raw array for .map function
// 1 - let settingsElements = Array.prototype.slice.call( document.getElementById('consent-fields').children );
// 2 - [...document.getElementById('consent-fields').children]